import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { TimerService } from '../../../UI-Lib/Utilities';
import { ProcessingService } from '../../processing.service.upgrade';

import * as _ from 'lodash';

@Component({
    selector: 'document-processing-search',
    templateUrl: './documentProcessingSearch.component.html',
    standalone: false,
})
export class DocumentProcessingSearchComponent implements OnInit, OnDestroy {
    constructor(
        private readonly _processingService: ProcessingService,
        private readonly _timerService: TimerService,
        private readonly _toastr: ToastrService,
    ) {}

    @Input() currentDocument: any;
    @Input() showCriteria: boolean;
    @Input() criteria: any;
    @Input() resultTypes: any;
    @Input() attachmentTypeId: number;

    @Output() searchResultSelected: EventEmitter<any> = new EventEmitter();

    savingCriteria: boolean;

    private _destroy$: Subject<void> = new Subject();

    ngOnInit(): void {
        this._processingService.changeProcessingDocument$.pipe(takeUntil(this._destroy$)).subscribe((x) => {
            this.refreshCriteria();
        });
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    search(): void {
        if (this.currentDocument && this.currentDocument.intakeItem) {
            this.criteria.currentIntakeItemID = this.currentDocument.intakeItem.intakeItemID;
        }
        this.criteria.includeIntakeItemData = true;
        this.criteria.executeSearch = false;
        if (this.criteria.anticipated) {
            this.criteria.anticipatedAttachmentTypeID = this.attachmentTypeId;
        }

        this._timerService.setTimeout(() => {
            this.criteria.executeSearch = true;
        }, 0);

        this.showCriteria = false;
    }

    async saveCriteria(): Promise<void> {
        this.savingCriteria = true;

        try {
            await this._processingService.saveCriteria(_.omit(this.criteria, 'resultType'));
            this._toastr.success('Search criteria successfully saved.');
        } finally {
            this.savingCriteria = false;
        }
    }

    refreshCriteria(): void {
        _.assign(this.criteria, this._processingService.getCriteria());
    }
}
